module.exports = __webpack_public_path__ + "img/textarea-t.c4933618.svg";